import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { PRICE_TEMPLATE_MASTER_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const PriceTemplateMasterApi = createApi({
  reducerPath: "PriceTemplateMaster",
  baseQuery,
  tagTypes: ["PriceTemplateMaster"],
  endpoints: (builder) => ({
    getPriceTemplateMaster: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: PRICE_TEMPLATE_MASTER_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: PRICE_TEMPLATE_MASTER_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["PriceTemplateMaster"],
    }),
    getPriceTemplateMasterById: builder.query({
      query: (id) => {
        return {
          url: `${PRICE_TEMPLATE_MASTER_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["PriceTemplateMaster"],
    }),
    addPriceTemplateMaster: builder.mutation({
      query: (payload) => ({
        url: PRICE_TEMPLATE_MASTER_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PriceTemplateMaster"],
    }),
    updatePriceTemplateMaster: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${PRICE_TEMPLATE_MASTER_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["PriceTemplateMaster"],
    }),
    deletePriceTemplateMaster: builder.mutation({
      query: (id) => ({
        url: `${PRICE_TEMPLATE_MASTER_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PriceTemplateMaster"],
    }),
  }),
});

export const {
  useGetPriceTemplateMasterQuery,
  useGetPriceTemplateMasterByIdQuery,
  useAddPriceTemplateMasterMutation,
  useUpdatePriceTemplateMasterMutation,
  useDeletePriceTemplateMasterMutation,
} = PriceTemplateMasterApi;

export default PriceTemplateMasterApi;
